// ============================================================================
// DOMAIN VOCABULARY
// ============================================================================
/**
 * Core application domains used across the entire stack:
 * - Backend error classification
 * - SDK event categorization
 * - Logging and observability
 *
 * These represent user-facing business domains that can be used
 * for both success events (SDK) and error events (Backend).
 */
export const Domains = {
    // Core entities
    USER: 'user',
    BUSINESS: 'business',
    TENANT: 'tenant',
    ADMIN: 'admin',
    // Assets & Balances
    TOKEN: 'token',
    BALANCE: 'balance',
    // Wallets & Signing
    WALLET: 'wallet',
    SIGNING_ACCOUNT: 'signing-account',
    // Transactions & Operations
    TRANSACTION: 'transaction',
    PURCHASE: 'purchase',
    REDEMPTION: 'redemption',
    // Blockchain & Web3
    BLOCKCHAIN: 'blockchain',
    CONTRACT: 'contract',
    CHAIN: 'chain',
    // Campaigns & Engagement
    CAMPAIGN: 'campaign',
    TRIGGER_SOURCE: 'trigger-source',
    // Authentication & Security
    AUTHENTICATION: 'authentication',
    API_KEY: 'api-key',
    // Infrastructure
    FILE: 'file',
    WEBHOOK: 'webhook',
    EMAIL: 'email',
    AUDIT: 'audit',
};
//# sourceMappingURL=domains.js.map